import { render, staticRenderFns } from "./CarouselAutoplay.vue?vue&type=template&id=1a3f3d3f&"
import script from "./CarouselAutoplay.vue?vue&type=script&lang=js&"
export * from "./CarouselAutoplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports